import { render, staticRenderFns } from "./SupportServicePricing.vue?vue&type=template&id=b1d0d52e&"
import script from "./SupportServicePricing.vue?vue&type=script&lang=js&"
export * from "./SupportServicePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports